// Rotas do módulo Contratos de Automação.
// Padrão de arquivo de rotas por domínio: src/router/rotas/PosVendas.ts.
// `rotasContratosAutomacao` é concatenado em rotasRestritas (LayoutGeral);
// CRUD de cliente/proposta/obra é feito via modais na árvore (ListarClientes.vue — T9);
// as rotas de página "Novo/Editar Cliente" (DadosCliente.vue) ficaram órfãs desde então
// e foram removidas aqui. `Proposta de Automação` (DadosProposta.vue) e `Obra de
// Automação` (DadosObra.vue) são as rotas de detalhe alcançadas por duplo clique na
// árvore (ListarClientes.vue) e por duplo clique numa obra dentro de DadosProposta.vue
// (HAUT-17, HAUT-18) — T20 (Fase 6).
// `rotaPedidoPublico` (1 rota) é concatenado em rotasAbertas, sem subject/action (tela sem login).
export const rotasContratosAutomacao: any[] = [
  {
    path: "/contratos-automacao/clientes",
    name: "Clientes de Automação",
    component: () => import("@/views/ContratosAutomacao/ListarClientes.vue"),
    meta: {
      title: "Clientes de Automação",
      icon: "mdi-domain",
      subject: ["CONTRATO_AUTOMACAO"],
      action: ["read"],
      showMenu: true,
      grupo: "CONTRATOS_AUTOMACAO",
      grupoTitle: "Contratos Automação",
    },
  },
  {
    path: "/contratos-automacao/propostas/:id",
    name: "Proposta de Automação",
    component: () => import("@/views/ContratosAutomacao/DadosProposta.vue"),
    props: true,
    meta: {
      breadcrumb: "Clientes de Automação",
      title: "Proposta de Automação",
      icon: "mdi-domain",
      subject: ["CONTRATO_AUTOMACAO"],
      action: ["read"],
      showMenu: false,
      grupo: "CONTRATOS_AUTOMACAO",
      grupoTitle: "Contratos Automação",
    },
  },
  {
    path: "/contratos-automacao/obras/:id",
    name: "Obra de Automação",
    component: () => import("@/views/ContratosAutomacao/DadosObra.vue"),
    props: true,
    meta: {
      breadcrumb: "Clientes de Automação",
      title: "Obra de Automação",
      icon: "mdi-domain",
      subject: ["CONTRATO_AUTOMACAO"],
      action: ["read"],
      showMenu: false,
      grupo: "CONTRATOS_AUTOMACAO",
      grupoTitle: "Contratos Automação",
    },
  },
  {
    path: "/contratos-automacao/pedidos",
    name: "Pedidos de Automação",
    component: () => import("@/views/ContratosAutomacao/ListarPedidos.vue"),
    meta: {
      title: "Pedidos de Automação",
      icon: "mdi-clipboard-text-clock-outline",
      subject: ["PEDIDO_AUTOMACAO"],
      action: ["read"],
      showMenu: true,
      grupo: "CONTRATOS_AUTOMACAO",
      grupoTitle: "Contratos Automação",
    },
  },
  {
    path: "/contratos-automacao/pedidos/:id",
    name: "Pedido de Automação",
    component: () => import("@/views/ContratosAutomacao/DadosPedido.vue"),
    props: true,
    meta: {
      breadcrumb: "Pedidos de Automação",
      title: "Pedido de Automação",
      icon: "mdi-clipboard-text-clock-outline",
      subject: ["PEDIDO_AUTOMACAO"],
      action: ["read"],
      showMenu: false,
      grupo: "CONTRATOS_AUTOMACAO",
      grupoTitle: "Contratos Automação",
    },
  },
];

export const rotaPedidoPublico: any[] = [
  {
    path: "/automacao/pedido/:token",
    name: "Formulário de Pedido de Automação",
    layoutNome: "LayoutGeralAberto",
    props: true,
    component: () => import("@/views/ContratosAutomacao/FormularioPedidoCliente.vue"),
    meta: {
      title: "Pedido de Automação",
      showMenu: false,
      rotaPublica: true,
    },
  },
];
